<template>
	<div v-if="errors.length > 0" class="app-errors pos-wide">
		<api-error v-for="err in errors" :level="err.level" :message="err.message"></api-error>
	</div>
</template>

<script setup lang="ts">
import {ref, computed} from "vue";
import ApiError from "@fd/helpers/ApiError.vue";
import type { ApiError as Error } from "@/types/util/ApiError";

const props = defineProps<{
	errors: Error[]
}>();
</script>

<style>

</style>